import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
        <img
          src={category.imageUrl}
          alt={category.name}
          title={`${category.name} - 欧美一区二区`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-2">
          <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${category.icon} text-sm`}></i>
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-900">{category.name}</h3>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-2">{category.description}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-foreground-500">{category.articleCount} 篇文章</span>
          <span className="text-xs text-primary-600 font-medium whitespace-nowrap group-hover:translate-x-1 transition-transform inline-flex items-center gap-1">
            浏览分区 <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}